<div class="chatbot-outer-container" [class.is-dragging]="isDragging">
    <div
        class="resize-sash"
        (mousedown)="onSashMouseDown($event)"
        (touchstart)="onSashTouchStart($event)"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize panel"
    >
        <div class="sash-indicator">
            <div class="sash-dots">
                <mat-icon [svgIcon]="'more-vertical'" class="mat-icon-16"></mat-icon>
            </div>
        </div>
    </div>

    <div class="d-flex flex-row align-items-center justify-content-between psic-gap-2 psic-p-5 w-100 wh-100-background">
        <custom-choice-chip [field]="field1" class="w-324" (callback)="handleSelectedEvent($event)">
        </custom-choice-chip>
        <mat-icon [svgIcon]="'close'" class="mat-icon-24 p1-50-color pointerCursor" (click)="onClose()"></mat-icon>
    </div>

    <div class="body psic-gap-4 psic-px-6 psic-py-4">
        <!-- Chat view -->
        @if (showChat) {
        <div class="content-area psic-gap-4">
            <!-- QuickSight Chat Agent Container -->
            <div id="quicksight-chat-container" class="quicksight-chat-container"></div>
            @if (isChatLoading) {
            <div class="quicksight-chat-loading">
                <app-animation [src]="'dots_loader.json'" [loop]="true" [autoplay]="true"></app-animation>
                <p class="alt dg_mg-60-color">Loading Ask Hestia...</p>
            </div>
            } @if (showReloadButton) {
            <div id="launch-widget-btn" class="quicksight-chat-retry" (click)="retryQuickSightChat()">
                <mat-icon svgIcon="loading"></mat-icon>
                <p class="alt dg_mg-60-color">Click to retry loading chat</p>
            </div>
            }
        </div>
        } @else {
        <div class="content-area">
            <!-- Empty state -->
            <!-- Call summary header -->
            <div class="pb-2">
                @if (!showChat && (callSummaryText || summaryGenerated)) {
                <h5>
                    {{ summaryGenerated ? "Here's what happened so far" : "Here's the call summary" }}
                </h5>
                }
            </div>
            <!-- Call summary content -->
            <div class="message-area-outer-wrap" style="padding: 0px">
                @for (summary of generatedSummaries; track summary; let i = $index) {
                <div class="messages-area-widget">
                    <div class="message-header-widget">
                        <mat-icon svgIcon="custom-ai-avatar" class="mat-icon-24"></mat-icon>
                        <p class="alt-bold dg_mg-80-color">AI assistant</p>
                    </div>
                    <div class="alt message-d d-flex flex-column justify-content-between gap-3">
                        <div>
                            <p class="alt-bold dg_mg-60-color">
                                {{ i === 0 ? 'Pre-escalation summary: ' : 'Here’s a recap of the conversation:' }}
                            </p>
                            <p class="p-alt dg_mg-60-color">{{ summary.timestamp }}</p>
                            <p class="alt-bold dg_mg-60-color">
                                {{ summary.attributes?.PolicyNo ? `Policy number ${summary.attributes.PolicyNo}` : 'Non-authenticated user' }}
                            </p>
                        </div>
                        <div class="d-flex flex-column">
                            <div style="display: flex; flex-direction: column">
                                <p class="alt-bold dg_mg-60-color">Customer number:</p>
                                <p class="alt dg_mg-60-color">{{ summary.callerNumber || '' }}</p>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px">
                                <p class="alt-bold dg_mg-60-color">Sentiment:</p>
                                <p class="alt dg_mg-60-color" style="text-transform: capitalize; margin: 0">
                                    {{ summary.attributes?.sentiment || 'neutral 😐' }}
                                    {{
                                        summary.attributes?.sentiment === 'positive'
                                            ? '😀'
                                            : summary.attributes?.sentiment === 'neutral'
                                            ? '😐'
                                            : summary.attributes?.sentiment === 'negative'
                                            ? '😡'
                                            : summary.attributes?.sentiment === 'mixed'
                                            ? '😡😀'
                                            : ''
                                    }}
                                </p>
                            </div>
                            <div style="display: flex; align-items: center; gap: 8px">
                                <p class="alt-bold dg_mg-60-color">Contact channel:</p>
                                <p class="alt dg_mg-60-color" style="text-transform: capitalize">
                                    {{ summary.attributes?.contactChannel || 'N/A' }}
                                </p>
                            </div>
                            
                            <div style="display: flex; align-items: center; gap: 8px">
                                <p class="alt-bold dg_mg-60-color">Persona:</p>
                                <p class="alt dg_mg-60-color" style="text-transform: capitalize">
                                    {{ ivrSelectedRole() || summary.attributes?.persona || 'N/A' }}
                                </p>
                            </div>
                            
                        </div>
                        <p class="p-alt dg_mg-60-color">
                            {{ summary.text }}
                        </p>
                    </div>
                    @if (i > 0) {
                    <lib-button
                        [buttonText]="'edit'"
                        [buttonTheme]="'primary'"
                        [buttonType]="'normal'"
                        [buttonSize]="'medium'"
                        [fontWeight]="'bold'"
                        [disabled]="recentPolicyNumbers.length === 0"
                        (callback)="reviewNotes(summary.text)"
                    ></lib-button>
                    }
                </div>
                } @if (isSummaryLoading) {
                <div class="messages-area-widget">
                    <div class="message-header-widget">
                        <mat-icon svgIcon="custom-ai-avatar" class="mat-icon-24"></mat-icon>
                        <p class="alt-bold dg_mg-80-color">AI assistant</p>
                    </div>
                    <div class="d-flex loading-container justify-content-center">
                        <div class="loading-indicator text-center">
                            <p class="alt dg_mg-60-color">Call summary in progress</p>
                            <app-animation
                                [class.d-none]="!isSummaryLoading"
                                [src]="'dots_loader.json'"
                                [loop]="true"
                                [autoplay]="true"
                            ></app-animation>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class="d-flex flex-row" style="gap: 12px; margin-top: 16px">
                <button
                    style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        height: 40px;
                        padding: 10px 16px;
                        border-radius: 24px;
                        border: 2px solid var(--p3-50);
                        background: transparent;
                        color: var(--p3-50);
                        cursor: pointer;
                        font-weight: 600;
                        font-family: Poppins-SemiBold, sans-serif;
                        font-size: 14px;
                    "
                    (click)="generateSummary()"
                >
                    Generate summary
                </button>
                <button
                    style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        height: 40px;
                        padding: 10px 16px;
                        border-radius: 24px;
                        border: 2px solid var(--p3-50);
                        background: transparent;
                        color: var(--p3-50);
                        cursor: pointer;
                        font-weight: 600;
                        font-family: Poppins-SemiBold, sans-serif;
                        font-size: 14px;
                    "
                    (click)="fetchCallIntent()"
                >
                    Call intent
                </button>
            </div>
        </div>
        }

        <!-- Call summary view -->

        <ng-template #reviewPanelContent>
            <div class="d-flex flex-column">
                <h6>{{ reviewNotesField.caption }}</h6>
                <p class="alt dg_mg-60-color" style="color: var(--dg_mg-60); margin-bottom: 16px">
                    Use the Call Summary to add a note to each policy.
                </p>
            </div>
            <div class="d-flex flex-column" style="gap: 8px">
                @for (policy of savedEditions; track policy) {
                <div
                    style="
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        height: 40px;
                        padding: 0 16px;
                        border-radius: 8px;
                        background-color: #e5f0e5;
                        color: #004c00;
                        margin-top: 8px;
                    "
                >
                    <mat-icon [svgIcon]="'check-circle'" style="font-size: 16px"></mat-icon>
                    <p class="alt-bold dg_mg-60-color">{{ getLobForPolicy(policy) }}</p>
                </div>
                }
                <app-dynamic-form [fields]="reviewNotesField?.options?.optionsList" [parentFormArray]="reviewNotesForm">
                </app-dynamic-form>
                <div class="d-flex justify-content-end">
                    <lib-button
                        buttonText="Update Notes"
                        buttonSize="medium"
                        buttonType="borderless"
                        [libIcon]="'icon-save'"
                        (callback)="onSaveEdition()"
                    >
                    </lib-button>
                </div>
            </div>
        </ng-template>

        <ng-template #reviewPanelFooter>
            <lib-button buttonText="Cancel" buttonType="borderless" (callback)="cancelReviewNotes()"></lib-button>
            <lib-button
                [disabled]="!isSaveEnabled()"
                buttonText="Submit Notes"
                (callback)="onSaveReviewNotes()"
            ></lib-button>
        </ng-template>
    </div>
</div>
